// Styles

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/styles/variables.scss';




// Vuetify
import { createVuetify } from 'vuetify'

const sportipsTheme = {
  dark: false,
  colors: {
    background: "#f6f8fd",
    'on-background': "#14213D",

    primary: '#F29200',
    'on-primary': "#000",

    dark: '#14213D',
    'on-dark': '#f5f7f8',

    'dark-red': '#581e1e',
    'dark-green': '#23581e',

    'primary-dark': "#cf7c00",

    'darkgrey': "#5e5e5e",

    darkblue: "#14213D",
    white: '#FFF',
    'on-white': "#14213D",
    grey_1: "#fafafa",
    grey_3: "#f7f7f7",
    'on-grey_3': "#14213D",
    grey_4: "#e5e5e5",
    'on-grey_4': "#14213D",

    "lightblue": "#e8effc",


  }

}


export default createVuetify(
  {
    icons: {
      defaultSet: 'mdi',
    },
    theme: {
      defaultTheme: 'sportipsTheme',
      themes: {
        sportipsTheme,
      }
    },
    defaults: {
      global: {

      },
      VSheet: {
        elevation: 2,
        rounded: true,
      },
      VChip: {
        label: true,

      },
      VBtn: {
        variant: 'tonal',
      },
      VTextField: {
        density: 'compact',

      },
      VSelect: {
        density: 'compact',
      },
      VAutocomplete: {
        density: 'compact',
      },
      VRadio: {
        color: 'primary',
      },
      VDivider: {
        thickness: "2px",
      },
      VCheckbox: {
        density: 'compact',
      }

    }
  }
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
)
